import React from "react";
import { CouponCardType } from "../../../interface/interface";

function CouponCard({
  data: {
    title,
    period: { start, finish },
    payor,
    use,
  },
}: {
  data: CouponCardType | any;
}) {
  return (
    <div className="coupon-card">
      <div className="title">{title}</div>
      <div className="period">
        {start}~{finish}
      </div>
      <div className="payor">{payor}</div>
      <div className={`use ${use ? "already" : ""}`}>
        {use ? "사용" : "미사용"}
      </div>
    </div>
  );
}

export default CouponCard;
